import React from "react"
import {
  FormControlLabel,
  Checkbox,
  FormGroup,
  Switch,
  Box,
  Typography,
} from "@mui/material"

type CheckboxesShowcaseProps = {
    size: "small" | "medium"
}

const CheckboxesShowcase: React.FC<CheckboxesShowcaseProps> = ({size}) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
        <Typography className="text-xl font-bold">Checkboxes Showcase</Typography>
        <FormGroup>
            <FormControlLabel control={<Checkbox size={size} defaultChecked />} label="Label" />
            <FormControlLabel required control={<Checkbox size={size} />} label="Required" />
            <FormControlLabel disabled control={<Checkbox size={size} />} label="Disabled" />
        </FormGroup>
        <Typography className="text-xl font-bold">Switches Showcase</Typography>
        <FormGroup>
            <FormControlLabel control={<Switch size={size} defaultChecked />} label="Label" />
            <FormControlLabel required control={<Switch size={size} />} label="Required" />
            <FormControlLabel disabled control={<Switch size={size} />} label="Disabled" />
        </FormGroup>  
    </Box>
  )
}

export default CheckboxesShowcase
